import { Dispatch, SetStateAction, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import { IMiniCursoResponse } from '../../Interfaces/IMiniCurso';
// import styles from './styles.module.css';

import CloseIcon from '@mui/icons-material/Close';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import '../Main/styles/resultadosMobile.css';


interface IProps {
  currentWeek: IMiniCursoResponse[];
  isMenuOpen: boolean;
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>;
  videoSelectedID: number;
  setCurrentPosition: Dispatch<SetStateAction<number>>;
}

function MiniCursoMenu({currentWeek, setIsMenuOpen, isMenuOpen, videoSelectedID, setCurrentPosition }: IProps) {

  const [openli, setOpenli] = useState<boolean>(false);

  return (
    <>
      {isMenuOpen && (
        <Dialog
          open={isMenuOpen}
          fullScreen
          // className={`absolute min-h-[105vh] h-fit w-[100vw] top-0 right-0 bottom-0 bg-white py-10 px-4 z-[9999] overflow-y-scroll`}
          style={{
            // zIndex: zIndex ? zIndex + 1 : '',
            // zIndex: 9999, //para estar por encima del bottom navigation
            display: openli ? 'none' : '',
          }}
        >
          <CloseIcon
            onClick={() => setIsMenuOpen(false)}
            className="fixed bottom-10 right-10"
            sx={{ fontSize: 40, color: "red" }}
          />

          <DialogTitle>
            <div className='flex justify-between pr-4 items-center'>
              <p className='text-black font-bold text-left m-0 text-[1.5rem]'> Programación </p>
            </div>
          </DialogTitle>

          <DialogContent dividers>

            <div className='m-0 flex flex-col gap-1 min-h-[80vh] text-[1.4rem] overflow-y-hidden '>
              {currentWeek.length &&
                currentWeek.map((item: IMiniCursoResponse, i: number) => (
                  <div
                    key={i}
                    style={{ padding: '.2rem 1rem' }}
                    className={videoSelectedID === item.miniCursoVideoID ? 'bg-black text-white' : ''}
                    onClick={() => { setCurrentPosition(i); setIsMenuOpen(false); }}
                  >
                    <div className="text-left m-0 flex justify-between gap-2">
                      <p className="childrenList m-0">
                        { item.titulo }
                      </p>
                    </div>
                </div>
                ))}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default MiniCursoMenu;
